import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { applyBrandingColors, shepherdTheme } from '@companion-professional/branding';
import '@companion-professional/branding/shepherd/fonts.css';
import { App } from './App';
import './tailwind.css';

// The brand palette is written into the CSS variables that the Tailwind theme and the shared components (notably
// VideoPlayer) read from. This site only ever shows one brand, so the theme is applied once, synchronously, before the
// first render — that avoids the flash of default colors a React effect would leave.
applyBrandingColors(document.documentElement, shepherdTheme);

// Playback URLs are pre-signed and time-limited, and the page is a one-shot viewer, so there is no value in retrying a
// failed request behind the user's back.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
